// ============================================================================
// POLISH BIBLE PASSAGES - Biblia Gdańska / Biblia Warszawska
// ============================================================================
// Polskie fragmenty biblijne z odniesieniami Strong

export const biblePassagesPl = {
  "Geneza_1": {
    book: "Księga Rodzaju",
    chapter: 1,
    title: "Stworzenie świata",
    verses: [
      { number: 1, text: "Na początku Bóg stworzył niebo i ziemię.", strong: ["H7225", "H430", "H1254"] },
      { number: 2, text: "A ziemia była bezładna i pusta, i ciemność była nad przepaścią, a Duch Boży unosił się nad wodami.", strong: ["H776", "H8414", "H7307"] },
      { number: 3, text: "I rzekł Bóg: Niech będzie światłość! I stała się światłość.", strong: ["H430", "H559", "H216"] },
      { number: 4, text: "I widział Bóg światłość, że była dobra; i oddzielił Bóg światłość od ciemności.", strong: ["H430", "H7200", "H216", "H2896"] },
      { number: 5, text: "I nazwał Bóg światłość dniem, a ciemność nazwał nocą. I był wieczór i był poranek, dzień pierwszy.", strong: ["H430", "H7121", "H3117", "H3915"] },
      { number: 6, text: "I rzekł Bóg: Niech będzie sklepienie pośród wód i niech oddziela wody od wód.", strong: ["H430", "H7549", "H4325"] },
      { number: 7, text: "I uczynił Bóg sklepienie i oddzielił wody, które były pod sklepieniem, od wód, które były nad sklepieniem. I stało się tak.", strong: ["H430", "H6213", "H7549"] },
      { number: 8, text: "I nazwał Bóg sklepienie niebem. I był wieczór i był poranek, dzień drugi.", strong: ["H430", "H7121", "H8064"] },
      { number: 27, text: "I stworzył Bóg człowieka na swój obraz, na obraz Boży stworzył go; jako mężczyznę i niewiastę stworzył ich.", strong: ["H430", "H1254", "H120", "H6754"] },
      { number: 31, text: "I widział Bóg wszystko, co uczynił, a oto było bardzo dobre. I był wieczór i był poranek, dzień szósty.", strong: ["H430", "H7200", "H2896", "H3966"] }
    ]
  },
  "Psalm_23": {
    book: "Psalmy",
    chapter: 23,
    title: "Pan jest moim pasterzem",
    verses: [
      { number: 1, text: "Pan jest moim pasterzem, nie będę niczego potrzebował.", strong: ["H3068", "H7462", "H2637"] },
      { number: 2, text: "Sprawia, że leżę na zielonych pastwiskach, prowadzi mnie nad wody ciche.", strong: ["H7257", "H4999", "H5148", "H4325"] },
      { number: 3, text: "Odnawia moją duszę, prowadzi mnie ścieżkami sprawiedliwości ze względu na swoje imię.", strong: ["H7725", "H5315", "H5148", "H6664"] },
      { number: 4, text: "Chociażbym chodził ciemną doliną, nie będę się bał złego, bo Ty jesteś ze mną; Twoja laska i Twój kij są moją pociechą.", strong: ["H1980", "H1516", "H6757", "H3372", "H7626"] },
      { number: 5, text: "Przygotowujesz przede mną stół wobec moich wrogów; namaszczasz moją głowę oliwą, mój kielich jest pełny.", strong: ["H6186", "H7979", "H6887", "H1878", "H3563"] },
      { number: 6, text: "Zaprawdę dobroć i miłosierdzie będą mnie naśladować po wszystkie dni mojego życia, i będę mieszkał w domu Pańskim przez długie dni.", strong: ["H2896", "H2617", "H7291", "H3117", "H1004", "H3068"] }
    ]
  },
  "Jan_3": {
    book: "Ewangelia Jana",
    chapter: 3,
    title: "Jezus i Nikodem",
    verses: [
      { number: 16, text: "Albowiem tak Bóg umiłował świat, że Syna swego jednorodzonego dał, aby każdy, kto weń wierzy, nie zginął, ale miał żywot wieczny.", strong: ["G2316", "G25", "G2889", "G1325", "G5207"] },
      { number: 17, text: "Bo Bóg nie posłał Syna swego na świat, aby sądził świat, ale aby świat przez niego był zbawiony.", strong: ["G2316", "G649", "G2889", "G2919", "G4982"] },
      { number: 18, text: "Kto weń wierzy, nie będzie sądzony, a kto nie wierzy, już jest osądzony, bo nie uwierzył w imię jednorodzonego Syna Bożego.", strong: ["G4100", "G2919", "G3686", "G5207", "G2316"] }
    ]
  },
  "Filipian_4": {
    book: "List do Filipian",
    chapter: 4,
    title: "Pokój Boży",
    verses: [
      { number: 4, text: "Radujcie się zawsze w Panu; jeszcze raz mówię: Radujcie się!", strong: ["G5463", "G2962", "G3825"] },
      { number: 6, text: "Nie troszczcie się o nic, ale we wszystkim w modlitwie i błaganiu z dziękczynieniem powierzajcie wasze prośby Bogu.", strong: ["G3309", "G4335", "G1162", "G2169"] },
      { number: 7, text: "A pokój Boży, który przewyższa wszelki rozum, będzie strzegł waszych serc i myśli w Chrystusie Jezusie.", strong: ["G1515", "G2316", "G5242", "G3563", "G5432"] },
      { number: 13, text: "Wszystko mogę w tym, który mnie wzmacnia.", strong: ["G1411", "G1743", "G5547"] }
    ]
  }
};

export default biblePassagesPl;
